import React, { useEffect, useState } from 'react';
import { ContainedButton } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import { isMobileDevice } from 'common/utilities/utils';
import { useHistory } from 'react-router-dom';

export const windowResized = () => {
  return isMobileDevice(window.innerWidth);
};

const GiftCardHomePageComponent = props => {
  const { contentData } = props;
  const { headline, description, image, button, subHeadline } = contentData;
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const history = useHistory();
  useEffect(() => {
    window.addEventListener('resize', setMobileHeader(windowResized));
  }, [isMobile]);

  return (
    <React.Fragment>
      <div className='giftCard-banner-container'>
        <div className='grid-container'>
          <div className='giftCard-text-section'>
            {headline && <p className='smallTxtGiftCard'>{headline}</p>}
            {subHeadline && <h1 className='largeTextGiftCard'>{subHeadline}</h1>}
            {description && <p className='giftCard-description-section'>{description}</p>}
            {button && (
              <div className='giftCard-button-container'>
                <ContainedButton
                  data-testid='giftCard-button'
                  className='find-more-btn'
                  onClick={() => button?.fields?.url && history.push(button?.fields?.url)}
                >
                  <span>{button?.fields?.buttonText}</span>
                </ContainedButton>
              </div>
            )}
          </div>

          <ImageComponent
            data-testid='giftCard-image-component'
            srcFile={image?.fields?.file?.url}
            alt=''
            className='giftCard-image'
          />
        </div>
      </div>
    </React.Fragment>
  );
};
export default GiftCardHomePageComponent;
